import { render, staticRenderFns } from "./LoginRedirect.vue?vue&type=template&id=2a808d5e&"
import script from "./LoginRedirect.vue?vue&type=script&lang=ts&"
export * from "./LoginRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports